<template>
    <div class="shipping-policy-rules">
        <div class="h6 font-weight-bold">Active Shipping rules
            <slot></slot>
        </div>
        <div v-if="list.length === 0">If any rules are created - we will send sold products by the cheapest possibile delivery option.</div>
        <hr>
        <div class="pt-2">
            <Draggable
                v-model="list"
                :disabled="!enabled"
                ghost-class="ghost-draggble"
                v-bind="dragOptions"
                :move="changePriority"
                @start="dragging = true"
                @end="dragging = false"
            >
                <transition-group type="transition" name="flip-list">
                    <div v-for="(rule, index) in list" :key="rule.id" class="shipping-policy-rules__item">
                        <b-card>
                            <b-row no-gutters>
                                <b-col>
                                    <b-card-body :title="rule.title">
                                        <!-- <b-card-text>
                                            This is a wider card with supporting text as a natural lead-in to additional content.
                                        </b-card-text> -->
                                    </b-card-body>
                                </b-col>
                                <b-col cols="12" md="auto">
                                        <b-button
                                            @click="edit(rule.id)"
                                            block
                                            variant="primary-user"
                                            class="text-left">
                                                <i class="icon-edit"></i>
                                                <!-- <i class="icon-pencil"></i> -->
                                                Edit
                                            </b-button>
                                        <b-button
                                            @click="remove(index)"
                                            block variant="danger"
                                            class="text-left">
                                                <i class="icon-trash"></i> Remove
                                        </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </transition-group>
            </Draggable>
        </div>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable'
    export default {
        name: 'RulesList',
        data() {
            return {
                rules: [],
                list: this.$store.getters.shippingPolicyList,
                changePriorityList: [],
                enabled: true,
                dragging: false
            }
        },
        components: {
            Draggable
        },
        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: 'description',
                    disabled: false,
                    ghostClass: 'ghost-draggble'
                }
            }
        },
        methods: {
            changePriority(payload) {
                console.log(payload)
            },
            remove(index) {
                this.$store.commit('DELETE_RULE', index)
            },
            edit(id) {
                this.$emit('editShippingRule', id)
                this.$root.$emit('bv::show::modal', 'shipping-settings')
            }
        }
    }
</script>

<style lang="scss">
    .shipping-policy-rules__item {
        cursor: pointer;
    }
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost-draggble {
        opacity: 0.5;
        background: #c8ebfb;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/ShippingPolicySettings/components/RulesList.vue